import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import RequestFailed from "./RequestFailed";
import useNetworkStatus from "../../hooks/useNetworkStatus";
import { useFlags } from "launchdarkly-react-client-sdk";


export default function NetworkBanner({ 
  onlyOnPath = null, 
  enabled = true,
  isApiError = false,
  apiErrorMessage = "An error occurred. Please try again or contact us for further assistance."
}) {
  const location = useLocation();
  const { enableConsole } = useFlags();
  const { isOffline } = useNetworkStatus({ enableLogging: enableConsole });

  if (!enabled) return null;
  if (onlyOnPath && location.pathname !== onlyOnPath) return null;

  // Determine which error to show
  const shouldShowOfflineError = isOffline;
  const shouldShowApiError = isApiError && !isOffline;

  // Don't show anything if there's no error
  if (!shouldShowOfflineError && !shouldShowApiError) return null;

  const message = shouldShowOfflineError 
    ? "You are offline — please check your connection and try again."
    : apiErrorMessage;

  const attribute3 = shouldShowOfflineError ? "network_offline" : "login_error";

  return (
    <RequestFailed
      tabIndex={0}
      message={message}
      label="login"
      attribute1="login page"
      attribute3={attribute3}
    />
  );
}

NetworkBanner.propTypes = {
  onlyOnPath: PropTypes.string,
  enabled: PropTypes.bool,
  isApiError: PropTypes.bool,
  apiErrorMessage: PropTypes.string,
};